import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DesksTurnsService } from 'src/app/services/turns-services/desks-turns-service/desks-turns.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';

@Component({
  selector: 'app-turns-desks-breadcrumb-card',
  templateUrl: './turns-desks-breadcrumb-card.component.html',
  styleUrls: ['./turns-desks-breadcrumb-card.component.scss']
})
export class TurnsDesksBreadcrumbCardComponent implements OnInit {

  @Input() desks;
  filterOpened: boolean;
  viewDisposition;

  constructor(private router: Router,
              private userStorageService: UserStorageService,
              private desksTurnsService: DesksTurnsService) {
                this.viewDisposition = 'grid';
               }

  ngOnInit() {
    if (this.userStorageService.getFilterDesks()) {
      this.toggleBreadcrumbFilter();
    }
  }

  public toggleViewDisposition(viewDis) {
    this.viewDisposition = viewDis;
    this.desksTurnsService.toggleDesksDisposition(viewDis);
  }

  public createDesk() {
    this.router.navigate(['turns/desk']);
  }

  public toggleBreadcrumbFilter() {
    this.filterOpened = !this.filterOpened;
  }

  public search(event) {
    this.desksTurnsService.searchDesks(event.target.value);
  }

}
